import { Injectable, Inject, Optional, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, TimeoutError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';

export const HTTP_GLOBAL_TIMEOUT_MS = 'HTTP_GLOBAL_TIMEOUT_MS';

@Injectable()
export class TimeoutInterceptorService implements HttpInterceptor {

  constructor(
    @Optional() @Inject(HTTP_GLOBAL_TIMEOUT_MS) private timeoutMs?: number,
    @Inject(PLATFORM_ID) private platformId?: Object
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only apply timeout on the server during SSR
    if (!isPlatformServer(this.platformId)) {
      return next.handle(req);
    }
    const effectiveTimeout = typeof this.timeoutMs === 'number' && this.timeoutMs > 0 ? this.timeoutMs : 28000;
    return next.handle(req).pipe(
      timeout(effectiveTimeout),
      catchError((err) => {
        if (err instanceof TimeoutError) {
          // Log timeout details for observability (SSR only)
          console.error(`http timeout ${req.method} ${req.url} exceeded ${effectiveTimeout} ms`);
          // Re-throw with a clearer error for upstream handling
          throw new Error(`Request timed out after ${effectiveTimeout} ms: ${req.method} ${req.url}`);
        }
        throw err;
      })
    );
  }
}


